export default __webpack_public_path__ + "static/media/scholar_5.e013ed1b.jpg";